import { FC } from "react";
import { PageContentWrapper } from "./LayoutStyles";

const Page: FC = ({ children }) => {
  return <PageContentWrapper>{children}</PageContentWrapper>;
};

export default Page;
